import { render, staticRenderFns } from "./BlueprintInventory.vue?vue&type=template&id=462259b6&"
import script from "./BlueprintInventory.vue?vue&type=script&lang=ts&"
export * from "./BlueprintInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports